/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import {styled } from 'fierry/react.old';

import Container from 'fierry/react.old/skeleton/pane/container';


export default styled(Container)`
`;
